<template>
    <tool-panel ref="panel" @close="$emit('close')">
        <template #header>
            <tool-panel-header
                :title="$t('menu.favorites')"
                :show-fullscreen="false"
                @close="$refs.panel.close()"
            >
                <template #right>
                    <font-awesome-icon
                        icon="plus"
                        class="action-icon"
                        tabindex="0"
                        role="button"
                        :title="$t('favorites.add')"
                        @click="$refs.favorites.addNew = true"
                        @keydown.enter="$refs.favorites.addNew = true"
                    />
                </template>
            </tool-panel-header>
        </template>
        <favorites ref="favorites" @shortcut-clicked="onShortcut" />
    </tool-panel>
</template>

<script>
import ToolPanel from '../toolbar/ToolPanel.vue'
import ToolPanelHeader from '../toolbar/ToolPanelHeader.vue'
import Favorites from './Favorites.vue'

export default {
    name: 'FavoritesPanel',
    components: { ToolPanel, ToolPanelHeader, Favorites },
    emits: ['close', 'shortcutClicked'],
    methods: {
        onShortcut(view, item) {
            this.$emit('shortcutClicked', view, item)
            // In full screen view, hide toolbar automatically
            const toolsFullscreen = window.innerWidth < 1200;
            if (toolsFullscreen) {
                this.$refs.panel.close()
            }
        }
    }
}
</script>

<style scoped>
</style>
